export const M3ErrorCodes: {
  ERROR_TRANSACTION_FINALIZATION_FAILED: number;
  ERROR_FACE_LOGIN_REQUIRED: number;
  ERROR_EVERTEC_VOUCHER_ALREADY_CREATED: number;
  ERROR_EVERTEC_VOUCHER_WITH_DIFFERENT_AMOUNT: number;
  ERROR_VIRTUAL_VOUCHER_ALREADY_REDEEMED: number;
  ERROR_CUSTOMER_NOT_APPROVED_FOR_OFFERS: number;
} = {
  ERROR_TRANSACTION_FINALIZATION_FAILED: 10390,
  ERROR_FACE_LOGIN_REQUIRED: 10443,
  ERROR_EVERTEC_VOUCHER_ALREADY_CREATED: 10486,
  ERROR_EVERTEC_VOUCHER_WITH_DIFFERENT_AMOUNT: 10487,
  ERROR_VIRTUAL_VOUCHER_ALREADY_REDEEMED: 10485,
  ERROR_CUSTOMER_NOT_APPROVED_FOR_OFFERS: 10120,
};

export default M3ErrorCodes;
